import { DialogActions, DialogContent, FormControlLabel, Grid, Radio, RadioGroup, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { XsBaseDialog, XsButton } from '../../../global/ui';
import RequestTypeDialogStore from './RequestTypeDialogStore';

function RequestTypeDialog() {
  const { t } = useTranslation();
  const history = useHistory();
  const [selected, setSelected] = useState<string>(RequestTypeDialogStore.requestType);

  const handleClose = () => {
    RequestTypeDialogStore.close();
  };

  const handleContinue = () => {
    RequestTypeDialogStore.setRequestType(selected === 'reimbursement' ? 'reimbursement' : 'reservation');
    RequestTypeDialogStore.close();
    history.push('/request');
  };

  return (
    <XsBaseDialog
      open={RequestTypeDialogStore.isOpen}
      onClose={handleClose}
      title={t('request_type_dialog.title')}
      maxWidth='sm'
      fullWidth
    >
      <DialogContent>
        <RadioGroup value={selected} onChange={(e) => setSelected(e.target.value)}>
          <Grid container direction='column' spacing={2} className='pt-2'>
            <Grid item>
              <FormControlLabel
                value='reservation'
                control={<Radio />}
                label={
                  <Grid container direction='column'>
                    <Grid item>{t('request_type_dialog.option_reservation_label')}</Grid>
                    <Grid item>
                      <Typography variant='caption' color='text.secondary'>
                        {t('request_type_dialog.option_reservation_description')}
                      </Typography>
                    </Grid>
                  </Grid>
                }
                sx={{ alignItems: 'flex-start', mb: 1 }}
              />
            </Grid>
            <Grid item>
              <FormControlLabel
                value='reimbursement'
                control={<Radio />}
                label={
                  <Grid container direction='column'>
                    <Grid item>{t('request_type_dialog.option_reimbursement_label')}</Grid>
                    <Grid item>
                      <Typography variant='caption' color='text.secondary'>
                        {t('request_type_dialog.option_reimbursement_description')}
                      </Typography>
                    </Grid>
                  </Grid>
                }
                sx={{ alignItems: 'flex-start' }}
              />
            </Grid>
          </Grid>
        </RadioGroup>
      </DialogContent>
      <DialogActions>
        <Grid container justifyContent='space-between' style={{ padding: '0 8px 8px' }}>
          <Grid item>
            <XsButton label='request_type_dialog.cancel_button' variant='contained' onClick={handleClose} />
          </Grid>
          <Grid item>
            <XsButton label='request_type_dialog.continue_button' variant='contained' onClick={handleContinue} />
          </Grid>
        </Grid>
      </DialogActions>
    </XsBaseDialog>
  );
}

export default observer(RequestTypeDialog);

